export default (values) => ({
  ...values,
  name: values.name || '',
  maternalName: values.maternalName || '',
  paternalName: values.paternalName || '',
  phone: values.phone || '',
  email: values.email || '',
});
